import { linkPayScheduleRepo } from "../../../data/repository/scheduled.repository";

export const LinkPayScheduleUseCase = async (scheduled) => {
  try {
    const resp = await linkPayScheduleRepo(scheduled);
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
